import { render, staticRenderFns } from "./sameIndustry.vue?vue&type=template&id=7afd860b&scoped=true"
import script from "./sameIndustry.vue?vue&type=script&lang=js"
export * from "./sameIndustry.vue?vue&type=script&lang=js"
import style0 from "./sameIndustry.vue?vue&type=style&index=0&id=7afd860b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afd860b",
  null
  
)

export default component.exports